import React from "react";
import { DialogActions, InnerDialogActions, SubmitButton } from "./styles";
import { CircularProgress } from "../../../../../CircularProgress";

type Props = {
  isLoading: boolean;
  buttonText: string;
  onSubmit: VoidFunction;
};

export function Survey({ isLoading, buttonText, onSubmit }: Props) {
  return (
    <DialogActions color={"primary"} $isSubmitted={false}>
      <InnerDialogActions>
        <SubmitButton
          color={"primary"}
          align="center"
          type="button"
          disabled={isLoading}
          startIcon={
            isLoading ? (
              <CircularProgress size="xs" color={"black"} />
            ) : undefined
          }
          text={isLoading ? "" : buttonText}
          onClick={onSubmit}
        />
      </InnerDialogActions>
    </DialogActions>
  );
}
